import * as React from 'react';
import { Button, Icon } from '@symphony-ui/uitoolkit-components';
import ApiServerURL from 'models/ApiServerUrl';
const MessagesFileButtons = ({ fileMeta }) => {
    const onClickFile = React.useCallback((fileMeta) => () => {
        // Create a new link
        const anchor = document.createElement('a');
        const url = new ApiServerURL('/syndicate/emails/attachment');
        url.searchParams.append('id', fileMeta.id);
        anchor.href = url.toString();
        anchor.download = fileMeta.name;
        // Append to the DOM
        document.body.appendChild(anchor);
        // Trigger `click` event
        anchor.click();
        // Remove element from DOM
        document.body.removeChild(anchor);
    }, []);
    return (React.createElement("div", { style: { marginRight: '0.5rem' } }, fileMeta?.map(f => (React.createElement(Button, { size: "small", key: f.id, onClick: onClickFile(f), title: f.name, iconButton: true },
        React.createElement(Icon, { iconName: 'download' }))))));
};
export default MessagesFileButtons;
